import React from 'react';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';

// ReactRouter
import { Route, Switch } from 'react-router-dom';

// Components
import Loading from '_components/Loading';

// Utils
import { routes } from 'utils/routes';
import { lazyScreen } from 'utils/lazyScreen';

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="HarlowAPP">
      <Helmet
        titleTemplate="% - Harlow"
        defaultTitle="Harlow"
      >
        <meta name="description" content="Harlow APP" />
      </Helmet>
      <React.Suspense fallback={<Loading />}>
        <Switch>
          {
          routes.public.map(routeItem => (
            <Route
              key={routeItem.path}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazyScreen(routeItem.componentPath)}
            />
          ))
        }
          <Route component={React.lazy(() => import('containers/Templates'))} />
        </Switch>
      </React.Suspense>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
        icon={false}
      />
    </div>
  );
}

export default React.memo(App);
